/**
 * AgentStatusIndicator — shows live progress of backtest/grid_search/walk_forward
 * operations in the AppHeader. Idle: small gray "Idle" text.
 * Active: blue label + percent + thin progress bar with tooltip.
 */

import { useAgentStatusStore } from '../../stores/agentStatusStore.js';

export function AgentStatusIndicator() {
  const status = useAgentStatusStore((s) => s.status);
  const label = useAgentStatusStore((s) => s.label);
  const current = useAgentStatusStore((s) => s.current);
  const total = useAgentStatusStore((s) => s.total);
  const percent = useAgentStatusStore((s) => s.percent);

  if (status === 'idle') {
    return <span className="text-xs text-gray-500 select-none">Idle</span>;
  }

  const clampedPercent = Math.min(100, Math.max(0, percent));

  return (
    <div
      className="flex flex-col items-end gap-0.5 min-w-0"
      title={`${current} / ${total}`}
    >
      <span className="text-xs text-blue-400 truncate max-w-[160px]">
        {label} {Math.round(clampedPercent)}%
      </span>
      <div
        role="progressbar"
        aria-valuenow={clampedPercent}
        aria-valuemin={0}
        aria-valuemax={100}
        className="w-20 h-1 bg-gray-700 rounded-full overflow-hidden"
      >
        <div
          className="h-full bg-blue-500 rounded-full transition-all duration-200"
          style={{ width: `${clampedPercent}%` }}
        />
      </div>
    </div>
  );
}
